/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolBiotechIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-biotech"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.63 21.45Q5.08 21.45 4.69 21.06Q4.3 20.68 4.3 20.13Q4.3 19.57 4.69 19.19Q5.08 18.8 5.63 18.8L9.4 18.8L9.4 17.35L9.4 17.35Q7.22 17.35 5.76 15.75Q4.3 14.15 4.3 11.95Q4.3 10.43 5.09 9.14Q5.88 7.85 7.22 7.17Q7.03 7.88 7.21 8.56Q7.4 9.25 7.88 9.82Q7.4 10.2 7.17 10.76Q6.95 11.32 6.95 11.95Q6.95 13.1 7.78 13.9Q8.6 14.7 9.75 14.7L16.88 14.7Q17.43 14.7 17.81 15.09Q18.2 15.47 18.2 16.02Q18.2 16.57 17.81 16.96Q17.43 17.35 16.88 17.35L13.55 17.35L13.55 18.8L18.38 18.8Q18.93 18.8 19.31 19.19Q19.7 19.57 19.7 20.13Q19.7 20.68 19.31 21.06Q18.93 21.45 18.38 21.45ZM13.45 11.4L13.45 11.4L13.45 11.4Q13.03 11.53 12.63 11.34Q12.22 11.15 12.05 10.72L11.93 10.4Q12.57 9.97 12.94 9.31Q13.3 8.65 13.3 7.88Q13.3 6.55 12.29 5.67Q11.28 4.8 9.9 4.8L9.82 4.55Q9.7 4.15 9.88 3.77Q10.05 3.4 10.45 3.25L10.45 3.25L10.45 3.25Q10.3 2.88 10.53 2.48Q10.75 2.08 11.53 1.8Q11.93 1.65 12.29 1.85Q12.65 2.05 12.75 2.45L12.75 2.45L12.75 2.45Q13.18 2.27 13.6 2.48Q14.03 2.67 14.18 3.1L16.4 9.15Q16.55 9.57 16.36 9.96Q16.18 10.35 15.75 10.5L15.75 10.5L15.75 10.5Q15.9 10.93 15.65 11.34Q15.4 11.75 14.63 12.03Q14.25 12.15 13.9 11.96Q13.55 11.78 13.45 11.4ZM10.22 9.45Q10.22 9.45 9.9 9.45Q9.57 9.45 9.11 8.99Q8.65 8.53 8.65 7.88Q8.65 7.22 9.11 6.76Q9.57 6.3 10.22 6.3Q10.88 6.3 11.34 6.76Q11.8 7.22 11.8 7.88Q11.8 8.53 11.34 8.99Q10.88 9.45 10.22 9.45Z" fill={color} />
    </svg>
  );
}
